import { render, staticRenderFns } from "./activosTable.vue?vue&type=template&id=3b9d78b5&"
import script from "./activosTable.vue?vue&type=script&lang=js&"
export * from "./activosTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports